var resources = require('items-view-strings');
    var strings = resources['_2wu2tWbHkPfWE96Tzhqb9w'];
export { strings };
export default strings;
